import { Suspense, useEffect } from "react";
import { MotionConfig } from "motion/react";
import { useLocation } from "react-router-dom";
import { Footer } from "../components/layout/Footer";
import { Navbar } from "../components/layout/Navbar";
import { LoadingScreen } from "../components/ui/LoadingScreen";
import { AppRoutes } from "./routes";

export function App() {
  return (
    <MotionConfig reducedMotion="user">
      <Suspense fallback={<LoadingScreen />}>
        <ScrollManager />
        <Navbar />
        <div id="main-content" tabIndex={-1}>
          <AppRoutes />
        </div>
        <Footer />
      </Suspense>
    </MotionConfig>
  );
}

function ScrollManager() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.slice(1));
      if (element) {
        element.scrollIntoView({
          behavior: window.matchMedia("(prefers-reduced-motion: reduce)")
            .matches
            ? "instant"
            : "smooth",
          block: "start",
        });
        return;
      }
    }

    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname, location.hash]);

  return null;
}
